document.addEventListener('DOMContentLoaded', function () {
    const authorizeRadio = document.getElementById('accept');
    const refuseRadio = document.getElementById('refuse');
    const checkboxes = [
        document.getElementById('legal_presentative_confirmed'),
        document.getElementById('data_processing_consented')
    ];

    const form = document.getElementById("legal-representative-form");

    // Vérification que les éléments existent avant de continuer
    if (!form || !authorizeRadio || !refuseRadio || checkboxes.some(cb => cb === null)) {
        return; // Arrête l'exécution si des éléments nécessaires manquent
    }

    const submitButton = form.querySelector('input[type="submit"]');
    const emailInput = form.querySelector('#email');
    const radioButtons = [authorizeRadio, refuseRadio];

    if (!submitButton || !emailInput) {
        return;
    }

    // Désactiver le bouton "Envoyer" par défaut
    submitButton.disabled = true;

    // Fonction pour activer/désactiver les cases à cocher selon le choix du bouton radio
    function toggleCheckboxes(isEnabled) {
        checkboxes.forEach(checkbox => {
            checkbox.required = isEnabled;
            checkbox.disabled = !isEnabled;
            if (!isEnabled) {
                checkbox.checked = false;
            }
        });
    }

    // Fonction pour vérifier si toutes les conditions sont remplies
    function checkFormValidity() {
        const isEmailValid = emailInput.value.trim() !== "" && emailInput.checkValidity();
        const areCheckboxesChecked = checkboxes.every(checkbox => checkbox.checked);
        const isRadioSelected = radioButtons.some(radio => radio.checked);
        const isAuthorizeSelected = authorizeRadio.checked;

        submitButton.disabled = !(isEmailValid && isRadioSelected && (!isAuthorizeSelected || areCheckboxesChecked));
    }

    // Initialisation de l'état des cases à cocher et de la validité du formulaire
    if (authorizeRadio.checked) {
        toggleCheckboxes(true);
    } else if (refuseRadio.checked) {
        toggleCheckboxes(false);
    }
    checkFormValidity();

    // Ajouter des écouteurs d'événements
    authorizeRadio.addEventListener('change', function () {
        if (this.checked) {
            toggleCheckboxes(true);
        }
        checkFormValidity();
    });

    refuseRadio.addEventListener('change', function () {
        if (this.checked) {
            toggleCheckboxes(false);
        }
        checkFormValidity();
    });

    emailInput.addEventListener("input", checkFormValidity);
    checkboxes.forEach(checkbox => checkbox.addEventListener("change", checkFormValidity));
});